import * as React from 'react';
import { useDispatch } from 'react-redux';

import { useFiltersContext } from '../../../../packages/Filters/shared/utils/useFiltersContext';
import { resetTerms } from '../../../../packages/JsonQuery';
import { justChangeJsonQuery } from '../../../common/actions/filters/justChangeJsonQuery';
import { closeSearchResultsSidebar } from '../../../common/actions/searchResults';
import { EmptyListing } from '../../../common/components/EmptyListing';
import { useActiveFilters } from '../../../common/hooks/useActiveFilters';
import { getResettableFilters } from '../../../common/utils/getResettableFilters';

interface IEmptyListingContainerProps {
  onShow: () => void;
}

// Контейнер для EmptyListing на десктопе с логикой активных фильтров
export const EmptyListingContainer = ({ onShow }: IEmptyListingContainerProps) => {
  const dispatch = useDispatch();
  const { jsonQuery, onApply } = useFiltersContext();
  const { activeFilters, hasActiveFilters } = useActiveFilters();
  const resettableFilters = React.useMemo(() => getResettableFilters(jsonQuery), [jsonQuery]);

  const onResetAllFilters = React.useCallback(() => {
    // Получаем все фильтры, которые можно сбросить
    if (resettableFilters.length > 0) {
      // Сбрасываем все фильтры кроме исключенных
      const nextJsonQuery = resetTerms(resettableFilters)(jsonQuery);
      dispatch(justChangeJsonQuery({ nextJsonQuery }));
      onApply();
      dispatch(closeSearchResultsSidebar());
    }
  }, [dispatch, jsonQuery, onApply, resettableFilters]);

  return (
    <EmptyListing
      onShow={onShow}
      activeFilters={activeFilters}
      showResetAllFiltersButton={activeFilters.length > 1 || !hasActiveFilters}
      onResetAllFilters={onResetAllFilters}
    />
  );
};
